// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__ukVo-","insightsList":"newBusinessInsightsMenu_insightsList__fAWP3","active":"newBusinessInsightsMenu_active___Qv8i"};